import { defineComponent as _defineComponent } from 'vue';
import { defineComponent, toRefs } from 'vue';
import { useHelpManager } from '@/entities/manager/model';
import ManagerInfo from '@/entities/manager/ui/ManagerInfo.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ContactsContent',
  setup: function setup(__props) {
    defineComponent({
      name: 'ContactsContent'
    });
    var _toRefs = toRefs(useHelpManager()),
      managers = _toRefs.managers;
    return {
      __sfc: true,
      managers: managers,
      ManagerInfo: ManagerInfo
    };
  }
});